exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".textjustify[data-v-5c8a9ac8]{text-align:justify}", "", {"version":3,"sources":["/opt/build/repo/src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/payroll-proposal/payroll-proposal-description.vue"],"names":[],"mappings":"AACA,8BACA,kBAAmB,CAClB","file":"payroll-proposal-description.vue","sourcesContent":["\n.textjustify[data-v-5c8a9ac8] {\ntext-align:justify;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c8a9ac8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/payroll-proposal/payroll-proposal-description.vue
// module id = 2851
// module chunks = 36